export default {
    lang: {
        name: 'For trade'
    }
}